import styled, { css } from "styled-components";

export const SPACE_PREFIX = "--spacing-";
export type Gap = "0" | "6" | "12" | "18" | "24" | "36";

export type Stack = {
    gap?: Gap;
    stick_to_sides?: boolean;
    distribute_evenly?: boolean;
    fill_width?: boolean;
    stick_to_top?: boolean;
    center_horizontally?: boolean;
    stick_to?: "bottom" | "top";
    padding_sides?: Gap;
    stick_text_to_right?: boolean;
};

export const VStack = styled.div<Stack>`
    display: flex;
    flex-direction: column;
    row-gap: var(${(props) => SPACE_PREFIX + props.gap});
    ${(props) =>
        props.padding_sides &&
        css`
            padding-left: var(${SPACE_PREFIX + props.padding_sides});
            padding-right: var(${SPACE_PREFIX + props.padding_sides});
        `}
    ${(props) =>
        props.stick_text_to_right &&
        css`
            text-align: end;
        `}
    ${(props) =>
        props.fill_width &&
        css`
            width: 100%;
        `}
    ${(props) =>
        props.stick_to_top &&
        css`
            align-items: flex-start;
        `}
`;

export const HStack = styled.div<Stack>`
    display: flex;
    flex-direction: row;

    ${(props) =>
        props.center_horizontally &&
        css`
            justify-content: center;
        `}

    ${(props) =>
        props.stick_to
            ? props.stick_to === "top"
                ? css`
                      align-items: flex-start;
                  `
                : css`
                      align-items: baseline;
                  `
            : css`
                  align-items: center;
              `}

    column-gap: var(${(props) => SPACE_PREFIX + props.gap});
    ${(props) =>
        props.stick_to_sides &&
        css`
            justify-content: space-between;
        `}

    ${(props) =>
        props.distribute_evenly &&
        css`
            justify-content: space-around;
        `}

    ${(props) =>
        props.fill_width &&
        css`
            width: 100%;
        `}
`;

type VCenter = {
    fill_width?: boolean;
    fill_height?: boolean;
    stick_to_top?: boolean;
    no_horizontal_center?: boolean;
};
export const VCenter = styled.div<VCenter>`
    display: flex;
    flex: 1;
    flex-direction: column;

    ${(props) =>
        props.fill_width &&
        css`
            width: 100%;
        `}

    ${(props) =>
        props.fill_height &&
        css`
            height: 100%;
        `} //TODO: придумать какой-то аргумент покрасивше, чем этот
    ${(props) =>
        !props.no_horizontal_center &&
        css`
            align-items: center;
        `}

    justify-content: center;

    row-gap: var(--spacing-0);
`;
